import {v4 as uuidv4} from 'uuid';

import img1 from '../../assets/img/certificates/1.png';
import img2 from '../../assets/img/certificates/2.png'; 
import img3 from '../../assets/img/certificates/3.png';
import img4 from '../../assets/img/certificates/4.png';
import img5 from '../../assets/img/certificates/5.png';
import img6 from '../../assets/img/certificates/6.png';
import img7 from '../../assets/img/certificates/7.png';
import img8 from '../../assets/img/certificates/8.png'; 
import img9 from '../../assets/img/certificates/9.png';
import img10 from '../../assets/img/certificates/10.png';
import img11 from '../../assets/img/certificates/11.png';
import img12 from '../../assets/img/certificates/12.png';
import img13 from '../../assets/img/certificates/13.png';
import img14 from '../../assets/img/certificates/14.png';
import img15 from '../../assets/img/certificates/15.png';


const AccData = [
    {
        id: uuidv4(),
        img: img1,
     
    },

    {
        id: uuidv4(),
        img: img2,
        
        
    },

    {
        id: uuidv4(),
        img: img3,
      
   
    },

    {
        id: uuidv4(),
        img: img4,
       
    },

    {
        id: uuidv4(),
        img: img5,
      
    },

    {
        id: uuidv4(),
        img: img6,
      
    },
    {
        id: uuidv4(),
        img: img7,
       
    },

    {
        id: uuidv4(),
        img: img8,
       
    },

    {
        id: uuidv4(),
        img: img9,
       
    },

    {
        id: uuidv4(),
        img: img10,
       
    },

    {
        id: uuidv4(),
        img: img12,
       
    },

    {
        id: uuidv4(),
        img: img14,
       
    },

    {
        id: uuidv4(),
        img: img15,
       
    },

    {
        id: uuidv4(),
        img: img11,
       
    },
    
    {
        id: uuidv4(),
        img: img13,
       
    },    

]

export default AccData;